import { useEffect } from 'react';

// Sets a unique document title for each page, always including the business name.
const BRAND = 'The Answer Group';

const usePageTitle = (title) => {
  useEffect(() => {
    document.title = title ? `${title} | ${BRAND}` : BRAND;
  }, [title]);
};

export default usePageTitle;
